export default "__VITE_ASSET__56b88b23__"